var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownLeft = function SvgArrowDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 15a.75.75 0 0 1-.75-.75v-7.5c0-.416.334-.75.75-.75s.75.334.75.75v5.69l7.219-7.221a.75.75 0 0 1 1.06 1.06l-7.22 7.218 5.691.003c.416 0 .75.334.75.75s-.334.75-.75.75z"
  })));
};
export default SvgArrowDownLeft;